import { render, staticRenderFns } from "./StandardEquipmentsTable.vue?vue&type=template&id=6f038b3e&scoped=true"
import script from "./StandardEquipmentsTable.vue?vue&type=script&lang=js"
export * from "./StandardEquipmentsTable.vue?vue&type=script&lang=js"
import style0 from "./StandardEquipmentsTable.vue?vue&type=style&index=0&id=6f038b3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f038b3e",
  null
  
)

export default component.exports